

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// getAllContactUsSections
// GETALLCONTACTUSSECTIONS
const GETALLCONTACTUSSECTIONS= createAsyncThunk(
  "getAllContactUsSections/getAllContactUsSections",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllContactUsSectionsSlice = createSlice({
  name: "getAllContactUsSectionsSlice",
  initialState: {
    PublishPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GETALLCONTACTUSSECTIONS.fulfilled, (state, action) => {
      state.getAllContactUsSections = {
        ...state.getAllContactUsSections,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCONTACTUSSECTIONS.pending, (state, action) => {
      state.getAllContactUsSections = {
        ...state.getAllContactUsSections,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCONTACTUSSECTIONS.rejected, (state, action) => {
      state.getAllContactUsSections = {
        ...state.getAllContactUsSections,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllContactUsSectionsAction = {
  GETALLCONTACTUSSECTIONS,
};

export { getAllContactUsSectionsAction };
export default getAllContactUsSectionsSlice.reducer;
